import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
/**
 * コンサルサーチ：ProffitのListItem用のスケルトン
 * @param props
 * @constructor
 */
export const CSearchProffitListItemSkeleton = (props) => {
    const { className } = props;
    return (_jsxs("div", Object.assign({ className: clsx('group', 'flex flex-col', 'p-12', 'gap-y-4', className) }, { children: [_jsx(Skeleton, { className: clsx('aspect-video', 'w-full') }), _jsx(Skeleton, { className: clsx('w-full h-[32px]') })] })));
};
